import React from 'react';

import { shape, string } from 'prop-types';

import ClassNames from 'classnames';

import BaseComponent from '../../.internal/BaseComponent';

import './TableFoot.scss';

export default class TableFoot extends BaseComponent {
  render() {
    const { style, id, className, children } = this.props;

    const classNames = ClassNames(['TableFoot', className]);

    return (
      <tfoot style={style} id={id} className={classNames}>
        {children}
      </tfoot>
    );
  }
}

TableFoot.propTypes = {
  style: shape({}),
  id: string,
  className: string
};

TableFoot.defaultProps = {
  style: {},
  id: undefined,
  className: undefined
};
